module.exports = __webpack_public_path__ + "static/media/08_tn.231aa966.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/thumbnails/08_tn.jpg
// module id = 222
// module chunks = 0